import { Show } from "solid-js";
import MinecraftText from "./MinecraftText";
import { useItemName } from "../hooks/useItemName";
import { toStack } from "../services/ahListing";
import type { AhListingDto } from "../api/generated/schemas";

// A listing carries a name of its own only where the seller renamed the item, so everything else is
// named from the viewer's own language pack rather than reading as blank.
export default function AhListingName(props: { listing: AhListingDto }) {
    const { stackName } = useItemName();
    const sellerName = () => props.listing.itemNameRaw?.trim();

    return (
        <Show when={sellerName()} fallback={<span>{stackName(toStack(props.listing))}</span>}>
            <MinecraftText text={sellerName()!} />
        </Show>
    );
}
